import React, { forwardRef, useState } from "react";
import PropTypes from "prop-types";
import { useThemeContext } from "../../context/themeContext";
import { Link } from "react-router-dom";

const Toggle = forwardRef(({
  name,
  onChange,
  required,
  label,
  className,
  readOnly,
  labelClassName,
  user,
  modal,
  defaultChecked,
  ...props
}, ref) => {
  const { theme } = useThemeContext();
  const [upgradeError, setUpgradeError] = useState(false);
  const [checkboxValue, setCheckboxValue] = useState((defaultChecked === "on" || defaultChecked == "1") ? "on" : (defaultChecked === "off" || defaultChecked == "0") ? "off" : defaultChecked);

  return (
    <>
      <label 
        className={`${className}`}
        onClick={(e) => {
          if ((user?.subscription?.Type === 1 && modal)) {
            e.preventDefault();
            setUpgradeError(true);
          }
        }}
      >
        <div className="flex flex-row justify-between items-center">
          {label && (
            <div>
              <span className={`${labelClassName && labelClassName} text-sportsBlack font-medium text-base leading-[26px]`}>
                {label}
              </span>
            </div>
          )}

          <div className="relative w-[51px] h-[31px]">
            <input
              name={name}
              onChange={(e) => {
                const value = e.target.checked ? 1 : 0;
                setCheckboxValue(value);
                if (onChange) {
                  onChange(e);
                }
              }}
              required={required}
              ref={ref}
              defaultChecked={(defaultChecked === "on" || defaultChecked == "1") ? 1 : (defaultChecked === "off" || defaultChecked == "0") ? 0 : defaultChecked}
              {...props}
              type="checkbox"
              className="peer hidden"
            />
            <span
              className={`
                absolute cursor-pointer top-0 left-0 right-0 bottom-0 bg-[rgba(120,120,128,0.16)] rounded-[100px] w-[51px] h-[31px] transition-all duration-500
                peer-disabled:opacity-40 peer-disabled:cursor-not-allowed 
                ${readOnly && "opacity-40 cursor-not-allowed"}
                ${theme === "staff" ? "peer-checked:bg-sportsBlue": "peer-checked:bg-sportsYellow"}
                peer-checked:before:left-[calc(100%-29px)]
                before:absolute before:top-[2px] before:left-[2px] before:transition-all before:h-[27px] before:w-[27px] before:rounded-full before:bg-white before:shadow-[0_3px_1px_0_rgba(0,0,0,0.06),0_3px_8px_0_rgba(0,0,0,0.15),0_0_0_1px_rgba(0,0,0,0.04)] before:duration-300
              `}
            ></span>
          </div>
        </div>

        {upgradeError && (
          <p className="text-base text-sportsRed mt-1">Automated emergency incident SMS to ICE contacts is only available on our silver and gold subscription levels. <Link to="/upgrade" className="underline font-semibold" onClick={() => { setOpen(false)}}>Upgrade Subscription</Link></p>
        )}
      </label>
      <input type="hidden" name={`${name}Value`} value={checkboxValue} />
    </>
  );
});

Toggle.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
};

export default Toggle;